module.exports = __webpack_public_path__ + "favorite.svg";